export default "__VITE_ASSET__fc1WWRb8__"